import React from 'react';
import '../../styles/Template4.css';
import logo from '../../uploads/logo.png';
import avatar from '../../uploads/avatar.png';
import earth from '../../uploads/earth.png';
import { Timeline } from 'antd';

const Template4 = ({ formData, educationData, languageData, computerSkillsData, employmentData, registrationAddress }) => {
    const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
	let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
    const reversedEmploymentData = employmentData.slice().reverse();
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };

	return (
		<>
		<div className="template4-container">
            <div className='avatar-box'>
                <img src={imageUrl} className='avatar' alt='avatar' />
            </div>
            <h1>{formData.Name}</h1>
            <div className='content-box-left'>
                <div className='content-box-left-item'>
                    <h3>контактные данные</h3>
                    <p>Номер телефона: {formData.MobilePhoneWork.value}</p>
                    <p>Почта: {formData.EmailPersonal}</p>
                    <p>Адрес: {registrationAddress.ViewAddresses}</p>
                </div>
                <div className='content-box-left-item'>
                    <h3>образование</h3>
                    {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                        <div key={`edu${index}`} className='content-box-left-education-item'>
                            <p>{edu.Institution.Name}</p>
                            <p>{edu.Faculty}</p>
                            <p>С {formatDate(edu.Start)} по {formatDate(edu.End)}</p>
                        </div>
                    ))}
                </div>
                <div className='content-box-left-item'>
                    <h3>знание языков</h3>    
                    {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                        <p key={`lang${index}`}>{lang.Language.Name} - {lang.LanguageDegree.Name}</p>                    
                    ))}                
                </div>
            </div>
            <div className='content-box-right'>
                <div className='content-box-right-item'>
                    <h3>о себе</h3>
                </div>
                <div className='content-box-right-item'>
                    <h3>опыт работы</h3>
                    <Timeline>
                    {!isObjectEmpty(reversedEmploymentData) && reversedEmploymentData.map((employment, index) => (
                        <Timeline.Item key={`emp${index}`}>
                            <div className='content-box-right-employment-item'>
                                <p>С {formatDate(employment.EmploymentDate)} по {employment.DismissalDate ? formatDate(employment.DismissalDate) : 'Н.В.'}</p>
                                <p>{employment.Organization}</p>
                                <h4>{employment.Position}</h4>
                                <ul><li><p>{employment.Duties}</p></li></ul>                            
                            </div>  
                        </Timeline.Item>                
                    ))}
                    </Timeline>             
                </div>
                <div className='content-box-right-item'>
                    <h3>компьютерные навыки</h3>
                    {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((skill, index) => (
                        <p key={`comp${index}`}>{skill.Software.Name} - {skill.SoftwareLevel.Name}</p>
                    ))}
                </div>
            </div>
        </div>
		</>
	);
};

export default Template4;
